import apis from '@api/api';
import DropDownView from '@components/Global/DropDownView';
import { Modal } from '@constants/Themed';
import { AntDesign } from '@expo/vector-icons';
import React, { useState, forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import { View, Text, Pressable, Linking, Platform, useWindowDimensions } from 'react-native';
import WebView from 'react-native-webview';

type PreviewModalProps = {
}

export type PreviewModalHandler = {
  openModal: (preview: any) => void;
  closeModal: () => void;
  replacedContent?: any;
}


const PreviewModal = forwardRef<PreviewModalHandler, PreviewModalProps>((props, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const [previewState, setPreviewState] = useState(null);
  const webView = useRef(null);
  const { width, height } = useWindowDimensions();

  const _handleGetTemplate = async (id) => {
    await apis.getTemplateById("email", id)
      .then(res => {
        setPreviewState(res);
      })
      .catch(err => {
        console.log(err);
      });
  }

  useEffect(() => {
    if (previewState?._id && !previewState.content) {
      console.log('no content detected')
      _handleGetTemplate(previewState._id);
    }
  }, [previewState])

  useImperativeHandle(ref, () => ({
    openModal: (preview) => {
      console.log(preview);
      setPreviewState(preview);
      setIsVisible(true)
    },
    closeModal: () => { setIsVisible(false); setPreviewState(null) }
  }));

  return (
    <Modal
      style={Platform.OS === 'web' && { minWidth: "70%", minHeight: "80%" }}
      hasBackdrop={false}
      setVisible={setIsVisible}
      containerStyle={{ borderRadius: 20, marginTop: 100, minHeight: Platform.select({ default: "80%", web: "80vh" }), minWidth: Platform.select({ default: "70%", web: "70vw" }) }}
      onBackdropPress={() => setIsVisible(false)}
      isVisible={isVisible}
    >
      
      <WebView
        scalesPageToFit
        automaticallyAdjustContentInsets
        ref={webView}
        style={{ 
          borderRadius: 20,
          minWidth: Platform.OS === 'web' ? width * 0.7 : '100%', 
          minHeight: Platform.OS === 'web' ? height * 0.7 : '100%'
        }}
        contentWidth={Platform.OS === 'web' ? width * 0.7 : width}
        onNavigationStateChange={(event) => {
          if (event.url.includes('http://') || event.url.includes('https://')) {
            webView.current?.stopLoading();
            Linking.openURL(event.url);
          }
        }}
        scrollEnabled
        source={{ html: previewState?.content?.template || previewState?.templateString || previewState?.content }} />
    </Modal>
  )
})
export default PreviewModal;